import { Preferences } from '@capacitor/preferences'
import{ getOnboardingSteps } from '../../helpers/dataFetcher'
import * as types from '../mutation-types'

async function getPreference (key) {
  const result = await Preferences.get({ key });
  return result.value ? JSON.parse(result.value) : null;
}

async function setPreference (key, value) {
  return await Preferences.set({ key, value: JSON.stringify(value) });
}

// state
export const state = {
    onboardingData: null,
    onboardingForm: null,
    subscriptionPortal: null,
    pendingSubscription: null
}
getPreference('onboardingForm').then((onboardingForm) => {
  state.onboardingForm = onboardingForm
})
getPreference('subscriptionPortal').then((subscriptionPortal) => {
  state.subscriptionPortal = subscriptionPortal
})
getPreference('onboardingData').then((onboardingData) => {
  state.onboardingData = onboardingData
})
getPreference('pendingSubscription').then((pendingSubscription) => {
  state.pendingSubscription = pendingSubscription
})

// getters
export const getters = {
    onboardingForm: state => state.onboardingForm,
    subscriptionPortal: state => state.subscriptionPortal,
    onboardingData: state => state.onboardingData,
    pendingSubscription: state => state.pendingSubscription
}

// mutations
export const mutations = {
  [types.SAVE_ONBOARDING_FORM] (state, onboardingForm) {
    state.onboardingForm = onboardingForm
  },

  [types.SAVE_SUBSCRIPTION_PORTAL] (state, subscriptionPortal) {
    state.subscriptionPortal = subscriptionPortal
  },

  [types.FETCH_ONBOARDING_STEPS_SUCCESS] (state, { onboardingSteps }) {
    state.onboardingForm = onboardingSteps.onboardingForm
    state.subscriptionPortal = onboardingSteps.subscriptionPortal
  },

  [types.UPDATE_ONBOARDING_FORM] (state, onboardingForm) {
    state.onboardingForm = onboardingForm
  },

  [types.UPDATE_SUBSCRIPTION_PORTAL] (state, subscriptionPortal) {
    state.subscriptionPortal = subscriptionPortal
  },

  [types.UPDATE_ONBOARDING_DATA] (state, onboardingData) {
    state.onboardingData = onboardingData
  },

  [types.SET_PENDING_SUBSCRIPTION] (state, subscriptionData) {
    state.pendingSubscription = subscriptionData
  },

  [types.CLEAR_PENDING_SUBSCRIPTION] (state) {
    state.pendingSubscription = null
  }
}

// actions
export const actions = {
  async fetchOnboardingSteps ({ commit, dispatch }) {
    const onboardingSteps = await getOnboardingSteps()
    commit(types.FETCH_ONBOARDING_STEPS_SUCCESS, { onboardingSteps })
    await setPreference('onboardingForm', onboardingSteps.onboarding_form)
    await setPreference('subscriptionPortal', onboardingSteps.subscription_portal)
    return onboardingSteps
  },
  async getOnboardingData () {
    const onboardingData = await getPreference('onboardingData')
    return onboardingData
  },
  async updateOnboardingData ({ commit }, { key, value }) {
    const onboardingData = await getPreference('onboardingData') || {}
    onboardingData[key] = value
    commit(types.UPDATE_ONBOARDING_DATA, onboardingData)
    await setPreference('onboardingData', onboardingData)
    return onboardingData
  },
  
  async setPendingSubscription ({ commit }, subscriptionData) {
    commit(types.SET_PENDING_SUBSCRIPTION, subscriptionData)
    await setPreference('pendingSubscription', subscriptionData)
  },

  async clearPendingSubscription ({ commit }) {
    commit(types.CLEAR_PENDING_SUBSCRIPTION)
    await setPreference('pendingSubscription', null)
  },

  async getPendingSubscription () {
    return await getPreference('pendingSubscription')
  },

  async clearOnboardingData ({ commit }) {
    commit(types.UPDATE_ONBOARDING_DATA, null)
    await setPreference('onboardingData', null)
  }
}